import React, { useEffect } from "react";
import "./Popular_Product.css";
import { useNavigate } from "react-router-dom";
import {
  getAllPopulerProduct,
  getAllProducts,
} from "../../../features/products/productsSlice";
import { useDispatch, useSelector } from "react-redux";
import { encodeId } from "../../../utils/common";

const Popular_Product = () => {
  const data = [
    {
      name: "Brocoli",
      img: "/assets/images/popular_products/img1.png",
      price: "₹ 500",
    },
    {
      name: "Nescafe Classic Coffee",
      img: "/assets/images/popular_products/img2.png",
      price: "₹ 500",
    },
    {
      name: "Brocoli",
      img: "/assets/images/popular_products/img1.png",
      price: "₹ 500",
    },
    {
      name: "Nescafe Classic Coffee",
      img: "/assets/images/popular_products/img2.png",
      price: "₹ 500",
    },
  ];

  const navigate = useNavigate();

  const dispatch = useDispatch();

 const PopulerProducts = useSelector((state) => state.product.allProducts);

  useEffect(() => {
    dispatch(getAllProducts({}));
  }, [dispatch]);

  console.log("PopulerProducts",PopulerProducts)

  return (
    <section className="Popular_Product">
      <div className="heading_div">
        <p className="card_title">Popular</p>
      </div>
      <section className="Product_Card">
        {PopulerProducts?.data?.map((item) => {
          return (
            <div
              className="prod_descn"
              onClick={() =>
                navigate(`/product-description/${encodeId(item?.id)}`)
              }
            >
              <div className="img_holder">
                <img
                  src={process.env.REACT_APP_IMG_URL + item?.image}
                  className="prod_img"
                />
              </div>
              <div className="text_holder">
                <p className="title">{item?.name}</p>
                <p className="price">₹ {item?.Product_Variants[0]?.price}</p>
              </div>
            </div>
          );
        })}
      </section>
    </section>
  );
};

export default Popular_Product;
